module.exports = __webpack_public_path__ + "static/media/U CERT.1ac9ddbb.svg";